import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=6bd77cba&scoped=true&"
import script from "./ListTemplate.vue?vue&type=script&lang=js&"
export * from "./ListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ListTemplate.vue?vue&type=style&index=0&id=6bd77cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd77cba",
  null
  
)

export default component.exports